<template>
    <svg aria-hidden="true" focusable="false" class="o-ico" :class="className">
        <use :xlink:href="url"></use>
    </svg>
</template>
<script>
const v = RESOURCE_REVISION.v;
const stylesheetDirectory = WPURLS.stylesheet_directory
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        className: {
            type: String,
            default: '',
        },
    },
    computed: {
        url() {
            return stylesheetDirectory + '/assets/img/sprite.svg#' + this.id;
        },
    },
};
</script>